import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import { Topic } from './data.class';
import { newTopicMessage } from '@/interfaces/topic-messages.interface';

const module = {
  state: {
    myTopics: Array<Topic>(),
    latestTopics: Array<Topic>(),
    myLatestTopics: Array<Topic>(),
    myCategoryTopics: Array<Topic>(),
    latestCategoryTopics: Array<Topic>(),
    activeTopic: Topic,
    topics: Array<Topic>(),
    reportingTopicMessage: newTopicMessage
  },
  mutations: mutations,
  actions: actions,
  getters: getters
};

export default module;
